import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Header.module.scss'

const Header = ({ children, className, ...restProps }) => (
  <header className={classnames(styles.root, className)} {...restProps}>
    {children}
  </header>
)

Header.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

export const Content = ({ children, className, ...restProps }) => (
  <div className={classnames(styles.content, className)} {...restProps}>
    {children}
  </div>
)

Content.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

export const SubHeader = ({ children, className, ...restProps }) => (
  <Header className={classnames(styles.subheader, className)} {...restProps}>
    {children}
  </Header>
)

SubHeader.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

export default Header
